import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');

const appContent = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(appContent, rootElement);
} else {
  ReactDOM.render(appContent, rootElement);
}

serviceWorker.unregister();